import { Component, Input, OnInit } from '@angular/core';
import {
  MatProgressSpinnerModule,
  ProgressSpinnerMode,
} from '@angular/material/progress-spinner';
import { Observable } from 'rxjs';
import { SharedModule } from '../../../_shared/shared.module';

import { LoaderService } from '../../services/loader.service';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
  standalone: true,
  imports: [SharedModule, MatProgressSpinnerModule],
})
export class LoaderComponent implements OnInit {
  color = 'primary';
  mode: ProgressSpinnerMode = 'indeterminate';
  value = 50;
  @Input() isLoading?: Observable<boolean>;

  constructor(private loaderService: LoaderService) {
    this.isLoading =
      this.isLoading !== undefined
        ? this.isLoading
        : this.loaderService.isLoading;
  }

  ngOnInit() {}
}
